import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { IClassroomAssignmentDayUnitListItemDTO } from '@app/infrastructure/models/classroom-assignment';
import { IGradeUnitListItemDTO } from '@app/infrastructure/models/grade-unit/grade-unit';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  template: `<app-shared-grade-unit-day-list-presentation
    [gradeUnitListItem]="gradeUnitListItem"
    [days]="gradeUnitDays | async"
    [unitNumber]="unitNumber"
    [gradeNumber]="gradeNumber"
  ></app-shared-grade-unit-day-list-presentation>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SharedGradeUnitDayListSmartComponent implements OnInit {
  gradeUnitListItem: Observable<IGradeUnitListItemDTO>;
  public days: BehaviorSubject<IClassroomAssignmentDayUnitListItemDTO[]> =
    new BehaviorSubject<IClassroomAssignmentDayUnitListItemDTO[]>([]);
  public gradeUnitDays = this.days.asObservable();

  public classroomId: string;
  public unitNumber: string;
  public gradeNumber: string;

  constructor(private activatedRoute: ActivatedRoute) {
    this.unitNumber = this.activatedRoute.snapshot.params.unitNumber;
    this.gradeNumber = this.activatedRoute.snapshot.params.gradeLevel;
  }

  ngOnInit(): void {
    const unit = 'gradeUnit';
    this.gradeUnitListItem = this.activatedRoute.snapshot.data[unit];
    this.days.next(this.activatedRoute.snapshot.data.gradeUnitDays.results);
  }
}
